/**
 * @return {{feature: string}}
 */
export const accountGamification = () => ({
  feature: 'gamification_gagne',
  cause: 'compte',
});
